
import { SpecialEvent } from '../../types/specialEvent';
import { bitcoinHalvingEvent } from './bitcoin-halving-event';
import { regulatoryShiftEvent } from './regulatory-shift-event';
import { techBreakthroughEvent } from './tech-breakthrough-event';
import { marketOpportunityEvent } from './market-opportunity-event';

export const specialEvents: SpecialEvent[] = [
  bitcoinHalvingEvent,
  regulatoryShiftEvent,
  techBreakthroughEvent,
  marketOpportunityEvent
];

export const getSpecialEventForYear = (year: number): SpecialEvent | null => {
  return specialEvents.find(event => event.triggerYears.includes(year)) || null;
};
